import { defineStore } from "pinia";

const COOKIE_NAME = "tt_consent";
const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;

function readCookie(name) {
    const match = document.cookie.match(
        new RegExp("(?:^|; )" + name + "=([^;]*)")
    );
    return match ? decodeURIComponent(match[1]) : null;
}

function writeCookie(name, value) {
    document.cookie = `${name}=${encodeURIComponent(value)}; max-age=${COOKIE_MAX_AGE_SECONDS}; path=/; SameSite=Lax`;
}

export const useConsentStore = defineStore("consentStore", {
    state: () => ({
        choice: readCookie(COOKIE_NAME),
        modalOpen: false,
    }),
    getters: {
        decided: (state) => state.choice !== null,
        externalAllowed: (state) => state.choice === "external",
    },
    actions: {
        set(choice) {
            this.choice = choice;
            writeCookie(COOKIE_NAME, choice);
            this.modalOpen = false;
        },
        open() {
            this.modalOpen = true;
        },
        close() {
            this.modalOpen = false;
        },
    },
});
